



















import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "ForwardButton",
  props: {
    text: {
      type: String,
      required: true
    },
    pointsBackwards: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("navigation", ["getActiveSection", "getSections"])
  },
  methods: {
    ...mapActions("navigation", ["setActiveSection"]),
    onForwardButtonClick: function() {
      this.$emit("click");
    }
  }
});
